<template>
  <div id="visit">
    <div class="page-header section-image" data-parallax="true" style="background-image: url('/static/img/activities.jpg'); height:50vh; background-position:0px 75%" >
      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto">
            <div class="brand text-center">
              <h1 class="title" id="hide_edit" @click="edit_visit">活動花絮</h1>
              <h3 class="title description">
                Activities
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- main-raised -->
    <div class="main">
      <div class="container">
        <!--nav pills -->
          <div class="section text-center">
            <div id="navigation-pills">
              <div class="row">
                <div class="col-md- ml-auto mr-auto">
                  <ul class="nav nav-pills nav-pills-rose">
                    <template v-for="(item, index) in planTypes">
                      <li class="nav-item"  :key="index">
                        <button class="nav-link" :class="{'active' : item == activePlanType}"  @click="getData(item)">{{ item.replace('_','、') }}</button>
                      </li>
                    </template>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        <!--end nav pills -->
        <div class="row">
          <template v-for="(item, index) in displayedPosts">
            <div class="col-md-3" :key="index">
              <router-link  :key="index" :to="{name:'plan_detail',params:{ id: item.id, planType: activePlanType, planTime: item.plan_time, planName: item.plan_name }}">
                <div class="card card-plain card-profile">
                  <div class="card-header card-header-image">
                      <img class="img img-raised" style="max-height: 200px; margin:auto;" :src="item.main_img">
                  </div>
                  <div class="card-body">
                    <h6 class="card-category text-info">{{ item.plan_time }}</h6>
                    <h4 class="card-title">
                      {{ item.plan_name }}
                    </h4>
                  </div>
                </div>
              </router-link>
            </div>
          </template>
        </div>
        <!-- =========================================== -->
        <nav aria-label="...">
          <ul class="pagination">
            <li class="page-item">
              <span class="page-link" v-if="page != 1" @click="page--">Previous</span>
            </li>

            <template v-for="(pageNumber, index) in pages.slice(page-1, page+5)">
              <li class="page-item" :class="{'active' : page == pageNumber}" :key="index">
                <a class="page-link" @click="page = pageNumber">{{pageNumber}} </a>
              </li>
            </template>

            <li class="page-item">
              <a class="page-link" v-if="page < pages.length" @click="page++">Next</a>
            </li>
          </ul>
        </nav>
        <!-- =========================================== -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "visit",
  props: [],
  components: {
    
  },
  data() {
    return {
      planTypes: ['政府_企業參訪', '研討會_論壇', '其他'],
      activePlanType: '研討會_論壇',
			page: 1,
			perPage: 8,
			pages: [],
      data: [],
    };
  },
  filters: {

  },
  computed:{
    displayedPosts () {
			return this.paginate(this.data);
		},
  },
  watch: {
    data () {
			this.setPages();
		},
  },
  methods: {
    getData: function(plan_type){
      var vm = this;
      vm.activePlanType = plan_type
      axios
        .post(`/api/getvisitEach`,{
          plan_type: plan_type
        })
        .then(res => {
          vm.data = res.data.data
        })
        .catch(err => {
          console.log(err);
        });
    },
		setPages () {
      let numberOfPages = Math.ceil(this.data.length / this.perPage);
      // console.log(`numberOfPages : ${numberOfPages}`)
      this.page = 1
      this.pages = []
			for (let index = 1; index <= numberOfPages; index++) {
				this.pages.push(index);
			}
		},
		paginate (posts) {
			let page = this.page;
			let perPage = this.perPage;
			let from = (page * perPage) - perPage;
			let to = (page * perPage);
			return  posts.slice(from, to);
    },
    edit_visit: function(){
      var vm = this;
      document.querySelector('#hide_edit').addEventListener('click', function (evt) {
          // console.log(evt.detail)

          if(evt.detail === 3){
              vm.$router.push("/edit_visit").catch(error => {
                  if (error.name != "NavigationDuplicated") {
                      throw error;
                  }
              });
          }
      });
    },
  },
  created() {
    this.getData(this.activePlanType);
  },
  mounted() {},
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/pages/visit/visit.vue